import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Config from './core/config/index';
import { auth } from './store/actions/auth';

import Auth from './containers/Auth/index';
import Payment from './containers/Payment/index';
import Layout from './hoc/Layout/index';
import Loader from './components/UI/Loader';

import {pushFunnelStepInfo} from './helpers/gtm';

function mapStateToProps(state) {
  return {
    actionInProgress: {
      authentication: state.auth.authenticationInProgress,
      getStaticData: state.payment.getStaticDataInProgress,
    },
    actionSuccess: {
      authentication: state.auth.authenticationSuccess,
      getStaticData: state.payment.getStaticDataSuccess,
    },
    actionError: {
      authentication: state.auth.authenticationError,
    },
    gtmData: state?.payment?.layoutStaticData?.gtmData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    auth: (payload) => dispatch(auth(payload)),
  };
}

class App extends Component {
  componentDidMount() {
    const { auth } = this.props;
    const {
      payment: { staticData },
    } = Config;
    const nodeStatic = document.getElementById(staticData);

    if (nodeStatic) {
      document.body.removeChild(nodeStatic);
    }
    auth(window[staticData]);
    pushFunnelStepInfo()
  }

  render() {
    const { actionInProgress, actionSuccess, actionError } = this.props;
    const loadingPageStatus =
      actionInProgress.authentication &&
      (!actionSuccess.getStaticData || !actionError.authentication);

    const routes = (
      <Switch>
        {!actionSuccess.authentication ? (
          <Route path="/" exact component={Auth} />
        ) : (
          <Route path="/" exact component={Payment} />
        )}
        <Redirect to="/" />
      </Switch>
    );

    return (
      <Layout>
        <>
          {loadingPageStatus ? <Loader /> : null}
          {routes}
        </>
      </Layout>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
